import { ReactElement } from 'react';
import Footer from 'components/Footer';
import MiniPlayer from 'components/MiniPlayer';
import { TopBar } from 'components/TopBar';
import { StyledContent, StyledDefaultLayout } from './styled';

type Props = {
  children: ReactElement;
  hasPlayer?: boolean;
  hideFooter?: boolean;
  hideTopBar?: boolean;
};
const DefaultLayout = ({
  children,
  hasPlayer = false,
  hideFooter = false,
  hideTopBar = false,
}: Props) => (
  <>
    <StyledDefaultLayout>
      {!hideTopBar && <TopBar />}
      <StyledContent>{children}</StyledContent>
      <MiniPlayer hidden={!hasPlayer} />
    </StyledDefaultLayout>
    {!hideFooter && <Footer />}
  </>
);

export default DefaultLayout;
